// extracted by mini-css-extract-plugin
export default {"icon":"IconSaturation_icon__x0fBO"};